import { useMemo } from "react";
import { requestStatus } from "../../../../../constants/statusConstants";
import Progress, {
  ApprovedDate,
  Assignee,
  Content1,
  CreatedDate,
} from "../../../components/Progress";
import ProgressLayout from "../../../components/layout/ProgressLayout";
import { useProcess } from "../../../process-context";
import { getStepClassByStatus, getStepIconByStatus } from "../../../util";
import { PinLayout } from "../../../components/layout/PinsLayout";

const ItCodeProgress = () => {
  const { Request } = useProcess();

  const progressData = useMemo(() => {
    const { fields, createdDateTime } = Request;

    const {
      eApprovedStatus,
      eApprovedByITLeadStatus,
      eAssigneeStatusDate,
      eApprovedByITHeadStatus,
      eApprovedBy,
      eApprovedDate,
      eApprovedByITLead,
      eApprovedByITLeadDate,
      eApprovedByITHead,
      eApprovedByITHeadDate,
      eAssignee,
      eAssigneeStatus,
    } = fields;

    return [
      {
        hidden: false,
        iconName: "faCheck",
        stepClassName: "approved",
        Content: (
          <Content1
            rank="Khởi tạo"
            title={Request.createdBy.user.displayName}
            subTitle={Request.createdBy.user.email}
            time={<CreatedDate value={createdDateTime} />}
          />
        ),
      },
      {
        hidden: !eApprovedBy,
        iconName: getStepIconByStatus(eApprovedStatus),
        stepClassName: getStepClassByStatus(eApprovedDate, eApprovedStatus),
        Content: (
          <Content1
            rank="Thủ trưởng CQ/ĐV"
            title={eApprovedBy.split("|")[1]}
            subTitle={eApprovedBy.split("|")[0]}
            time={<ApprovedDate value={eApprovedDate} />}
          />
        ),
      },
      {
        hidden: !eApprovedByITLead,
        iconName: getStepIconByStatus(eApprovedByITLeadStatus),
        stepClassName: getStepClassByStatus(eApprovedByITLeadDate, eApprovedByITLeadStatus),
        Content: (
          <Content1
            rank="Cán bộ CNTT"
            title={eApprovedByITLead.split("|")[1]}
            subTitle={eApprovedByITLead.split("|")[0]}
            time={<ApprovedDate value={eApprovedByITLeadDate} />}
          />
        ),
      },
      {
        hidden: !eApprovedByITHead,
        iconName: getStepIconByStatus(eApprovedByITHeadStatus),
        stepClassName: getStepClassByStatus(eApprovedByITHeadDate, eApprovedByITHeadStatus),
        Content: (
          <Content1
            rank="Đơn vị quản lý chương trình"
            title={eApprovedByITHead.split("|")[1]}
            subTitle={eApprovedByITHead.split("|")[0]}
            time={<ApprovedDate value={eApprovedByITHeadDate} />}
          />
        ),
      },
      {
        hidden: !eAssignee,
        iconName: getStepIconByStatus(eAssigneeStatus),
        stepClassName: getStepClassByStatus(eAssigneeStatusDate, eAssigneeStatus),
        Content: (
          <Content1
            rank="Hoàn tất / Nghiệm thu"
            title={eAssignee.split("|")[1]}
            subTitle={eAssignee.split("|")[0]}
            time={
              <Assignee>
                <Assignee.Date value={eAssigneeStatusDate} />
                <Assignee.Status assigneeStatus={eAssigneeStatus} requestStatus={requestStatus} />
              </Assignee>
            }
          />
        ),
      },
    ];
  }, [Request]);

  return (
    <ProgressLayout>
      <Progress
        title={<span>Quy trình duyệt - yêu cầu {Request.id} <PinLayout /></span>}
        data={progressData}
        getStepIcon={(item) => item.iconName}
        getStepClassName={(item) => item.stepClassName}
        getStepHidden={(item) => item.hidden}
        renderContent={(item) => item.Content}
      />
    </ProgressLayout>
  );
};

export default ItCodeProgress;
